import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
// import { Analytics } from '@vercel/analytics/react';

import Header from './v3/Header';
import './layout.css'
import './grid.scss'

const Layout = ({ children, className, isDarkBackground = false, isBlogPage = false }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header isBlogPage={isBlogPage} />
      <div>
        {/* <Analytics /> */}
        {children}
      </div>
    </>);
}

export default Layout
